<template>
  <c-view>
    <c-page>
      <c-navbar title="邀请有礼"></c-navbar>
      <c-content>
        <div style="padding:15px;">
          <h2>
            <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">【奖励条款】</span>
          </h2>
          <p>
            <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">1、邀请人数不限，多邀多得，上不封顶</span>
          </p>
          <p>
            <span
              style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"
            >2、现金奖励仅限于生意专家自营功能和服务，包括高级版、行业版、连锁后台、小程序及微信会员卡等（硬件设备不计入奖励）</span>
          </p>
          <p>
            <span
              style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"
            >3、被邀请人实际付款部分产生现金奖励，抵值券、积分、优惠券抵扣的部分不计奖励</span>
          </p>
          <p>
            <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">4、正在进行促销活动的功能和套餐不产生现金奖励</span>
          </p>
          <p>
            <span
              style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"
            >5、奖励金额为符合条件的消费金额之20%，直接通过微信公众号发送现金红包</span>
          </p>
          <h2>
            <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">【邀请条款】</span>
          </h2>
          <p>
            <span
              style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"
            >1、通过本页面的链接邀请，微信转发给老板、店长，注册后即与您的帐号关联</span>
          </p>
          <p>
            <span
              style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"
            >2、受邀者完成注册或消费后即产生奖金记录，您需要关注公众号领取，奖金将会通过现金红包的方式直接发放给您</span>
          </p>
          <h2>
            <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">【安全免责条款】</span>
          </h2>
          <p>
            <span
              style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"
            >1、奖金原则上尽快发放，也有可能风控原因延迟，具体情况根据页面中的邀请记录及相关状态为准</span>
          </p>
          <p>
            <span
              style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"
            >2、受邀者应为店主、老板、店长，并真实使用过生意专家提供的产品和服务</span>
          </p>
          <p>
            <span
              style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"
            >3、为了保护各方利益，如发现有“撸羊毛”等欺骗奖金的行为（不仅限于欺骗注册等），本公司将采用大数据及AI外呼进行风控，并予以取消奖励和关停帐号</span>
          </p>
          <p>
            <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">4、最终解释权归生意专家所有</span>
          </p>
          <p>
            <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">5、如有疑问请联系客服【YL8866】</span>
          </p>
        </div>
      </c-content>
    </c-page>
  </c-view>
</template>

<script>
export default {
  name: 'Provision',
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>



// WEBPACK FOOTER //
// index.vue?1e740e2e